import routes from 'sitewide-js/core_pre_webpack/routes';
import fetchWithCsrf from 'js/utils/fetch_with_csrf';
import { Paper, PaperLink } from 'js/social/shared/types';

export async function getWork(link: PaperLink): Promise<Paper> {
  const response = await fetchWithCsrf(
    routes.api_v0_community_work_path({ subdomain_param: 'api', ...link }),
  );
  if (!response.ok) {
    throw new Error(`Couldn't find that paper.`);
  }

  return (await response.json()).work;
}

export async function getPercentiles(
  workIds: number[],
): Promise<{ [workId: number]: string }> {
  const response = await fetchWithCsrf(
    routes.api_v0_works_percentiles_path({
      subdomain_param: 'api',
      work_ids: workIds,
    }),
  );
  if (!response.ok) {
    throw new Error(`Error fetching percentiles.`);
  }

  return (await response.json()).percentiles;
}

export async function bookmarkWork(
  contentId: number,
  contentType = 'Work',
): Promise<Response> {
  return fetchWithCsrf(
    routes.api_v0_bookmarks_path({ subdomain_param: 'api' }),
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        bookmark: {
          content_id: contentId,
          content_type: contentType,
          source: 'news', // This used to refer to the old feed, now reused for the social homepage
        },
      }),
    },
  );
}

export async function unbookmarkWork(
  contentId: number,
  contentType = 'Work',
): Promise<Response> {
  return fetchWithCsrf(
    routes.destroy_for_work_api_v0_bookmarks_path({ subdomain_param: 'api' }),
    {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        content_id: contentId,
        content_type: contentType,
      }),
    },
  );
}

export async function getProposedPostContentForWork(
  workId: number,
): Promise<string> {
  const response = await fetchWithCsrf(
    routes.api_v0_community_propose_a_post_index_path({
      subdomain_param: 'api',
    }),
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ work_id: workId }),
    },
  );
  if (!response.ok) {
    throw new Error(`Error fetching AI Post proposal.`);
  }

  return (await response.json()).propose_a_post;
}
